const { container } = require('@/container');

/**
 * @param {CartItemGroup} cartItemGroup
 * @param {GroupBookingReferenceModalResult} result
 */
const handleGroupBookingReferenceEdit = async (cartItemGroup, result) => {
    // Whether adding a new group booking reference, or renaming an existing one,
    // first set the reference of this group to the desired value.
    // Otherwise, the line we're working on wouldn't get updated.

    // You'd think we could just set the group booking reference on the group itself,
    // but if we are editing from a Vue component (e.g. the Cart preview) the group will
    // be a clone and not the original group in the cart.
    // So find the group in the cart and set the reference there.
    const cartItemGroupFromCart = container.cartService.getCartItemGroupByKey(cartItemGroup.key);
    if (!cartItemGroupFromCart) {
        throw new Error('Failed to find cart item group in cart by key: ' + cartItemGroup.key);
    }

    console.debug(
        `Setting new group booking reference "${result.newReference}" on all items in group`, cartItemGroupFromCart,
    );
    await container.cartService.modifyCurrentCart(() => {
        cartItemGroupFromCart.items.forEach((item) => {
            item.groupBookingReference = result.newReference;
        });
    });

    // Now, if we renamed an existing reference update all the other items in the cart that used the old ref.
    if (result.type === 'rename') {
        console.debug(
            `Renaming group booking reference from "${result.originalReference}" to "${result.newReference}" on all cart lines`,
        );
        await container.cartService.updateGroupBookingReference(
            result.originalReference,
            result.newReference,
        );
    }
};

module.exports = {
    handleGroupBookingReferenceEdit,
};
